import { CustomButtonProps } from "@/components/custom-button/custom-button-type";
import { ClaimButtonNFTStyle } from "./style-component";
import CustomButton from "@/components/custom-button/custom-button";
import { TypeReward } from "@/types/reward/reward";
import SparksOverlay from "@/components/sparks-overlay/sparks-overlay";
import WalletIcon from "@/assets/icons/wallet/wallet-icon";


interface ClaimButtonProps extends CustomButtonProps {
  isClaimed: boolean;
  rewardType: TypeReward;
  highlight?: boolean;
}

const ClaimButtonNFT: React.FC<ClaimButtonProps> = ({ rewardType, isClaimed, children, highlight, ...props }) => {

  if (isClaimed) {
    return (
      <ClaimButtonNFTStyle to={`/wallet`} $isErc721={rewardType === 'ERC721'}>
        ¡Ya tienes esta recompensa!
        <SparksOverlay />
        <span>
          {rewardType === 'ERC721' ? `Ver en mi wallet` : `Ver mi balance`}
          <WalletIcon size={16}/>
        </span>
      </ClaimButtonNFTStyle>
    )
  }

  return (
    <CustomButton
      data-testid="button-claim"
      type="primary"
      {...props}>
      {children}
      {highlight &&
        <SparksOverlay />
      }
    </CustomButton>
  )
}

export default ClaimButtonNFT;
